export default "__VITE_ASSET__WG5FFtvs__"